import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import { ICreateModifierGroupValidationError, IItemForGetShortInfo, IServerError } from 'types';
import classNames from 'classnames';
import style from './ModalSentErrorWithInfo.module.scss';

interface IModalSentErrorWithInfo {
	onConsentEvent: () => void;
	isVisible: boolean;
	errorResponseData: IServerError<ICreateModifierGroupValidationError> | null;
	fetchedRestaurants: IItemForGetShortInfo[];
	fetchedDishes: IItemForGetShortInfo[];
}

const ModalSentErrorWithInfo: React.FC<IModalSentErrorWithInfo> = ({
	onConsentEvent,
	isVisible,
	errorResponseData,
	fetchedDishes,
	fetchedRestaurants,
}) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const getAdditionalInfo = () => {
		return errorResponseData?.Metadata?.restaurants.map((el: { restaurantId: string; dishes: string[] }) => {
			const restaurantName =
				fetchedRestaurants.find((fetchedRestaurant) => fetchedRestaurant.id === el.restaurantId)?.name || null;
			const dishNames: string[] = [];
			for (let i = 0; i < el.dishes.length; i++) {
				for (let j = 0; j < fetchedDishes.length; j++) {
					el.dishes[i] === fetchedDishes[j].id && dishNames.push(fetchedDishes[j].name);
				}
			}
			return (
				<React.Fragment key={el.restaurantId}>
					<Text
						className={style.nameWrapper}
						translationNameSpace="modals"
						translationKey="restaurantDotHaveThis"
						values={{ restaurantName }}
						components={[
							<Text
								key="1"
								translationNameSpace="modals"
								translationKey="dishesLabel"
								asFragment={true}
							/>,
						]}
						size="xxl"
						weight="bold"
						align="center"
					/>
					<div className={style.additionalInfoItems}>
						{dishNames.map((dishName) => (
							<div className={style.nameWrapper} key={dishName}>
								<Text
									translationKey={dishName}
									theme="secondaryLight"
									size="l"
									weight="bold"
									withTooltip={true}
								/>
								,
							</div>
						))}
					</div>
				</React.Fragment>
			);
		});
	};

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<div className={style.closeIconWrapper} onClick={onConsentEvent}>
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				</div>
				<svg className={style.errorIcon}>
					<use xlinkHref={`${breadcrumbs}#error`} />
				</svg>
				<div className={style.description}>{getAdditionalInfo()}</div>
				<div className={style.btnWrapper}>
					<Button className={style.okBtn} theme="primaryBlue" onClick={onConsentEvent} type="submit">
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ModalSentErrorWithInfo);
